module.exports = __webpack_public_path__ + "static/assets/5c56b8d7ad1bc0d1c83b48ac01f5e534.svg";